// extracted by mini-css-extract-plugin
export default {"project":"project_project__kVCcQ","img":"project_img__f82dX"};